import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scoreColor, scoreVerdict } from "@/lib/severity";

export function ScoreGauge({ score }) {
  const [display, setDisplay] = useState(0);
  const color = scoreColor(score);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 900;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * score));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  const glow = score >= 85 ? "glow-neon" : score >= 60 ? "glow-warning" : "glow-critical";

  return (
    <div className="relative border border-border bg-surface bg-grid p-6 h-full flex flex-col justify-between overflow-hidden" data-testid="score-gauge">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Security Score</span>
        <span className="font-mono text-[10px] uppercase tracking-widest px-2 py-1 border" style={{ color, borderColor: color }}>
          {scoreVerdict(score)}
        </span>
      </div>

      <div className="flex items-end gap-2 py-4">
        <motion.span
          className={`font-display font-black leading-none ${glow}`}
          style={{ color, fontSize: "clamp(5rem, 14vw, 9rem)" }}
          data-testid="score-value"
        >
          {display}
        </motion.span>
        <span className="font-mono text-2xl text-muted-foreground mb-4">/100</span>
      </div>

      <div className="h-2 w-full bg-surface2 border border-border">
        <motion.div
          className="h-full"
          style={{ backgroundColor: color }}
          initial={{ width: 0 }}
          animate={{ width: `${score}%` }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        />
      </div>
    </div>
  );
}
